// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Modal from 'react-modal';

Modal.setAppElement('#root'); // Adjust if your root element has a different ID

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
